// extracted by mini-css-extract-plugin
export default {"container":"JackpotsContainer_container__nGd7+","overlay":"JackpotsContainer_overlay__HTztJ"};